import React, { useState } from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import GuestForm from "./guestInformation"; // ✅ Renamed import

import axios from "axios";
import TravelPlanForm from "./guestJourney";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const GuestFormComponent = () => {
  // ✅ Changed component name to avoid conflict
  const [guestData, setGuestData] = useState(null); // ✅ Ensure guestData is not an array
  const [journeyData, setJourneyData] = useState(null);
  const [open, setOpen] = useState(false); // ✅ State for popup

  const userId = localStorage.getItem("userId");

  const handleGuestSubmit = (data) => {
    setGuestData(data); // ✅ Ensure correct data format
  };

  const handleJourneySubmit = (data) => {
    setJourneyData(data);
  };

  const handleSubmitAll = async () => {
    if (!guestData || !journeyData) {
      alert("Please submit both forms before clicking Submit.");
      return;
    }

    const finalData = {
      userId: userId,
      ...guestData,
      ...journeyData,
    };

    console.log("Final Merged Data:", finalData);

    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/User/Guest_List`,
        finalData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setOpen(true); // ✅ Open popup after successful submission      // console.log("Response:", response.data);
    } catch (error) {
      console.error("Error submitting data:", error);

      alert(
        `❌ Error: ${error.response?.data?.error || "Failed to submit data"}`
      );
    }
  };

  return (
    <Box sx={{ margin: "80px" }}>
      <Box sx={{ marginTop: 4 }}>
        <GuestForm onSubmit={handleGuestSubmit} />
        <TravelPlanForm onSubmit={handleJourneySubmit} />

        <Button
          variant="contained"
          color="primary"
          className="mt-5"
          onClick={handleSubmitAll}
        >
          Submit All Data
        </Button>
      </Box>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "white",
            p: 4,
            borderRadius: 3,
            boxShadow: 24,
            textAlign: "center",
          }}
        >
          <Typography variant="h5" sx={{ mb: 2, color: "green" }}>
            🎉 Thank You!
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Your data has been successfully submitted.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => (window.location.href = "https://cosmicalevents.in/")} // ✅ Redirect to website
          >
            Visit Website
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

export default GuestFormComponent; // ✅ Export with the new name
